"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { IntlProvider, type MessageFormatElement } from "react-intl";
import { z } from "zod";
import useZodErrors from "utils/hooks/useZodErrors";

// Translate zod errors to the current locale
function ZodWrapper(t0) {
  const {
    children
  } = t0;
  const {
    makeZodI18nMap
  } = useZodErrors();
  z.setErrorMap(makeZodI18nMap());
  return children;
}
export default function ServerIntlProvider(t0) {
  const $ = _c(6);
  const {
    messages,
    locale,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ZodWrapper>{children}</ZodWrapper>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== locale || $[3] !== messages || $[4] !== t1) {
    t2 = <IntlProvider messages={messages} locale={locale}>{t1}</IntlProvider>;
    $[2] = locale;
    $[3] = messages;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}